import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { CopyChartService } from "../../../platform/api/copy-chart/copy-chart.service";

@Component({
    selector: "app-more-actions-modal",
    templateUrl: "./more-actions-modal.component.html",
    styleUrls: ["./more-actions-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreActionsModalComponent {
    private Visible = false;

    @Input()
    get visible(): boolean {
        return this.Visible;
    }
    set visible(value: boolean) {
        this.Visible = value;
        this.visibleChange.emit(this.visible);
    }

    @Input() message = "Bulk actions have a limit of 5000 chases.Your action will apply only to first 5000 chases in your list.Do you wish to continue ? ";

    @Output() continue = new EventEmitter<void>();
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onHide = new EventEmitter<null>(true);

    constructor(
        private readonly copyChartService: CopyChartService
    ) {}


    cancel(): void {
        this.copyChartService.clearChaseGrid();
        this.onHide.emit();
    }

    onContinue(): void {
        this.continue.emit();
        this.visible = false;
    }
}

